import GoogleCalendarIntegration from './google-calendar-integration'

export default GoogleCalendarIntegration
